import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './AdminSidebar.css';
import { Menu, Layout, Avatar, Typography, Badge, Button, Dropdown } from 'antd';
import { useAuth } from '../../hooks/useAuth';
import {
  DashboardOutlined,
  FileTextOutlined,
  UserOutlined,
  SettingOutlined,
  BarChartOutlined,
  FolderOutlined,
  EditOutlined,
  LogoutOutlined,
  BellOutlined,
  CloudUploadOutlined,
  MailOutlined,
  MenuOutlined,
  SoundOutlined,
  PictureOutlined
} from '@ant-design/icons';

const { Sider } = Layout;
const { Text } = Typography;

const AdminSidebar = ({ collapsed, onCollapse }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission, hasRole } = useAuth();

  const handleMenuClick = (e) => {
    navigate(e.key);
    if (window.innerWidth <= 900) {
      onCollapse(true);
    }
  };

  const menuItems = [
    {
      key: '/admin',
      icon: <DashboardOutlined />,
      label: 'لوحة التحكم',
      permission: 'view_dashboard',
    },
    {
      key: 'reports',
      icon: <BarChartOutlined />,
      label: 'التقارير والإحصائيات',
      permission: 'view_reports',
      children: [
        {
          key: '/admin/internal-reports',
          label: 'نظرة عامة',
        },
        {
          key: '/admin/internal-reports/users',
          label: 'تقرير المستخدمين',
        },
        {
          key: '/admin/internal-reports/activity',
          label: 'سجل النشاطات',
        },
        {
          key: '/admin/internal-reports/news',
          label: 'تقرير الأخبار',
        },
        {
          key: '/admin/internal-reports/reports',
          label: 'قائمة التقارير',
        },
        {
          key: '/admin/internal-reports/articles',
          label: 'تقرير المقالات',
        },
        {
          key: '/admin/internal-reports/messages',
          label: 'رسائل الاتصال',
        },
      ],
    },
    {
      key: '/admin/profile',
      icon: <UserOutlined />,
      label: 'الملف الشخصي',
    },
    {
      key: '/admin/messages',
      icon: <MailOutlined />,
      label: 'إدارة الرسائل',
      permission: 'view_messages',
    },
    {
      type: 'divider',
    },
    {
      key: 'content',
      icon: <FileTextOutlined />,
      label: 'إدارة المحتوى',
      children: [
        {
          key: '/admin/articles',
          label: 'المقالات',
          permission: 'view_articles',
        },
        {
          key: '/admin/news',
          label: 'الأخبار',
          permission: 'view_news',
        },
        {
          key: '/admin/sections',
          label: 'الأقسام',
          permission: 'view_sections',
        },
      ],
    },
    {
      key: 'ads',
      icon: <SoundOutlined />,
      label: 'الإعلانات',
      children: [
        {
          key: '/admin/ad-ticker',
          label: 'إضافة إعلان شريطي',
          icon: <MenuOutlined />,
          permission: 'edit_ads',
        },
        {
          key: '/admin/ad-popup',
          label: 'إضافة إعلان منبثق',
          icon: <PictureOutlined />,
          permission: 'edit_ads',
        },
      ],
    },
    {
      key: 'users',
      icon: <UserOutlined />,
      label: 'إدارة المستخدمين',
      children: [
        {
          key: '/admin/users',
          label: 'المستخدمين',
          permission: 'view_users',
        },
        {
          key: '/admin/activity-log',
          label: 'سجل النشاطات',
          permission: 'view_activities',
        },
        {
          key: '/admin/permissions',
          label: 'الصلاحيات',
          role: ['system_admin', 'admin'],
        },
      ],
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'الإعدادات',
      children: [
        {
          key: '/admin/settings',
          label: 'الإعدادات العامة',
          permission: 'view_settings',
        },
        {
          key: '/admin/nav-manager',
          label: 'التحكم في القائمة',
          icon: <MenuOutlined />,
          permission: 'edit_navigation',
        },
        {
          key: '/admin/backup',
          label: 'النسخ الاحتياطي',
          permission: 'manage_backup',
        },
      ],
    },
  ];

  const filterMenuItems = (items) => {
    return items
      .map((item) => {
        if (item.permission && !hasPermission(item.permission)) {
          return null;
        }
        if (item.role && !hasRole(item.role)) {
          return null;
        }
        if (item.children) {
          const filteredChildren = filterMenuItems(item.children);
          if (filteredChildren.length > 0) {
            return { ...item, children: filteredChildren };
          }
          return null;
        }
        return item;
      })
      .filter(Boolean);
  };

  return (
    <div className="admin-sidebar-container">
      <div className="admin-sidebar-header">
        <Avatar size={collapsed ? 40 : 64} icon={<UserOutlined />} />
        {!collapsed && <h3>لوحة التحكم</h3>}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={handleMenuClick}
        items={filterMenuItems(menuItems)}
      />
    </div>
  );
};

export default AdminSidebar;
